import * as React from 'react';
import OptionValueForm from "../../components/OptionValues/OptionValueForm/OptionValueForm";
var OptionType = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 Option Value"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-5 offset-md-4" },
                    React.createElement(OptionValueForm, null))))));
};
export default OptionType;



//////////////////
// WEBPACK FOOTER
// ./src/views/OptionValues/OptionValue.tsx
// module id = 380
// module chunks = 0